/*
 * This file is part of the Convergence API Server.
 *
 * (c) Convergence <https://convergence.finance/>
 */

import PropTypes from "prop-types";
import React from "react";
import { Query } from "react-apollo";
import { SPECIAL_INITIATIVE_SUMMARY_ANALYSIS_QUERY } from "../../../../graphql/query/DealQuery";
import SummaryAnalysisContainer from "./SummaryAnalysisContainer";
import AverageDealSizeByCountriesWidget from "./Widget/AverageDealSizeByCountriesWidget";
import AverageDealSizeByRegionsWidget from "./Widget/AverageDealSizeByRegionsWidget";
import AverageDealSizeBySDGsWidget from "./Widget/AverageDealSizeBySDGsWidget";
import AverageDealSizeBySectorsWidget from "./Widget/AverageDealSizeBySectorsWidget";
import AverageDealSizeByTypeWidget from "./Widget/AverageDealSizeByTypeWidget";
import DealSizesWidget from "./Widget/DealSizesWidget";
import DealTypesWidget from "./Widget/DealTypesWidget";
import TotalDealsByCountriesWidget from "./Widget/TotalDealsByCountriesWidget";
import TotalDealsByRegionsWidget from "./Widget/TotalDealsByRegionsWidget";
import TotalDealsBySDGsWidget from "./Widget/TotalDealsBySDGsWidget";
import TotalDealsBySectorsWidget from "./Widget/TotalDealsBySectorsWidget";
import TotalDealSizeWidget from "./Widget/TotalDealSizeWidget";
import TotalDealsWidget from "./Widget/TotalDealsWidget";
import TotalDealsBySubSectorsWidget from "./Widget/TotalDealsBySubSectorsWidget";
import AverageDealSizeBySubSectorsWidget from "./Widget/AverageDealSizeBySubSectorsWidget";

type Props = {
    initiative;
};
class SpecialInitiativeSummaryAnalysis extends React.Component<Props> {
    widgetGroups: {
        key: string;
        enableWidget: boolean;
        component: typeof TotalDealsWidget;
    }[][];

    static propTypes = {
        initiative: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        this.widgetGroups = [
            [
                {
                    key: "numberOfUniqueDeals",
                    enableWidget: true,
                    component: TotalDealsWidget
                },
                {
                    key: "totalDealVolume",
                    enableWidget: true,
                    component: TotalDealSizeWidget
                }
            ],
            [
                {
                    key: "dealSizeByRange",
                    enableWidget: true,
                    component: DealSizesWidget
                }
            ],
            [
                {
                    key: "numberOfDealsByType",
                    enableWidget: true,
                    component: DealTypesWidget
                },
                {
                    key: "averageDealSizeByType",
                    enableWidget: true,
                    component: AverageDealSizeByTypeWidget
                }
            ],
            [
                {
                    key: "numberOfDealsBySDG",
                    enableWidget: true,
                    component: TotalDealsBySDGsWidget
                },
                {
                    key: "averageDealSizeBySDG",
                    enableWidget: true,
                    component: AverageDealSizeBySDGsWidget
                }
            ],
            [
                {
                    key: "numberOfDealsBySector",
                    enableWidget: true,
                    component: TotalDealsBySectorsWidget
                },
                {
                    key: "averageDealSizeBySector",
                    enableWidget: true,
                    component: AverageDealSizeBySectorsWidget
                }
            ],
            [
                {
                    key: "numberOfDealsBySubSector",
                    enableWidget: true,
                    component: TotalDealsBySubSectorsWidget
                },
                {
                    key: "averageDealSizeBySubSector",
                    enableWidget: true,
                    component: AverageDealSizeBySubSectorsWidget
                }
            ],
            [
                {
                    key: "numberOfDealsByRegion",
                    enableWidget: true,
                    component: TotalDealsByRegionsWidget
                },
                {
                    key: "averageDealSizeByRegion",
                    enableWidget: true,
                    component: AverageDealSizeByRegionsWidget
                }
            ],
            [
                {
                    key: "numberOfDealsByCountry",
                    enableWidget: true,
                    component: TotalDealsByCountriesWidget
                },
                {
                    key: "averageDealSizeByCountry",
                    enableWidget: true,
                    component: AverageDealSizeByCountriesWidget
                }
            ]
        ];
    }

    render() {
        const { initiative } = this.props;
        return (
            <Query
                query={SPECIAL_INITIATIVE_SUMMARY_ANALYSIS_QUERY}
                variables={{
                    initiative
                }}
                fetchPolicy={"network-only"}
            >
                {({ loading, networkStatus, data, refetch }) => {
                    return (
                        <SummaryAnalysisContainer
                            data={
                                data && data.dealSummaryAnalysis
                                    ? data.dealSummaryAnalysis
                                    : null
                            }
                            // @ts-ignore POSSIBLE ERROR FOUND. no prop networkStatus
                            networkStatus={networkStatus}
                            loading={loading}
                            refetch={refetch}
                            dealType={"active"}
                            widgetGroups={this.widgetGroups}
                            disableFilter={true}
                        />
                    );
                }}
            </Query>
        );
    }
}

export default SpecialInitiativeSummaryAnalysis;
